import { Injectable } from '@angular/core';
import { CollectionPaths } from '@models/collections';
import { ReportingBusiness } from '@models/reporting';
import { Selector, State } from '@ngxs/store';
import {
	DEFAULT_STATE_BASE,
	FirestoreStateBaseCtx,
	FirestoreStateBaseStateModel,
} from '@state/FirestoreStateBase';
import { FirestoreStateBaseForBusinessWithSubscription } from '@state/FirestoreStateBaseForBusiness';

export interface MatterCountsModel {
	purchaseCount: number;
	refinanceCount: number;
	saleCount: number;
}

interface ReportingBusinessModel extends FirestoreStateBaseStateModel {
	purchaseCount: number;
	refinanceCount: number;
	saleCount: number;
}
type Ctx = FirestoreStateBaseCtx<ReportingBusinessModel>;

const DEFAULT_STATE: ReportingBusinessModel = {
	...DEFAULT_STATE_BASE,
	purchaseCount: 0,
	refinanceCount: 0,
	saleCount: 0,
};

@State<ReportingBusinessModel>({
	name: 'reportingBusiness',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class ReportingBusinessState extends FirestoreStateBaseForBusinessWithSubscription<
	ReportingBusiness,
	ReportingBusinessModel
> {
	@Selector([ReportingBusinessState])
	static getMatterCounts(state: ReportingBusinessModel): MatterCountsModel {
		return {
			purchaseCount: state?.purchaseCount ?? 0,
			refinanceCount: state?.refinanceCount ?? 0,
			saleCount: state?.saleCount ?? 0,
		};
	}

	@Selector([ReportingBusinessState.getMatterCounts])
	static hasMatters(matterCounts: MatterCountsModel): boolean {
		return Object.values(matterCounts).some(Boolean);
	}

	constructor() {
		super(
			() => CollectionPaths.reporting_businesses(),
			(payload) => payload as ReportingBusiness,
			() => DEFAULT_STATE,
		);
	}

	protected subscribeToBusinessChanges(ctx: Ctx): void {
		this.subscribeToDocChanges(ctx, this.businessId);
	}
}
